// extracted by mini-css-extract-plugin
export default {"HeroError":"heroError_HeroError__q-AEp"};